


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormattedTextCard from '@/components/FormattedTextCard.vue';
import Card from '@/components/Card.vue';
import { ICard, ICardSideStat, ICardStat } from '@thefirstspine/types-rest';
import optionsService from '../services/options.service';

@Component({
  components: {
    Card,
    FormattedTextCard,
  },
})
export default class CardInfo extends Vue {
  @Prop() private cardFocus?: ICard;
  @Prop() private cardStats?: ICardStat;
  @Prop() private cardFocusHolo?: boolean;
  @Prop() private cardFocusPremium?: boolean;
  @Prop() private cardStyle?: boolean;
  @Prop() private displayed?: boolean;
  @Prop() private cardColor?: string;

  public mounted() {
    setTimeout(
      () => {
        const parent = this.$el.parentElement;
        if (!parent) {
          return;
        }

        parent.addEventListener('mouseenter', () => {
          this.$data.visible = true;

          const parentPositionX = parent.getBoundingClientRect().left;
          const parentPositionY = parent.getBoundingClientRect().top;
          const parentWidth = parent.getBoundingClientRect().width;
          const parentHeight = parent.getBoundingClientRect().height;

          const thisHeight = this.$el.getBoundingClientRect().height;
          const totalHeight = window.innerHeight;

          const positionX = parentPositionX - 720 < 0 ? parentPositionX + parentWidth + 20 : parentPositionX - 720;
          const positionY = parentPositionY + thisHeight + 20 > totalHeight ?
            totalHeight - thisHeight - 20 :
            parentPositionY;

          this.$data.stylePosition = {
            top: `${positionY}px`,
            left: `${positionX}px`,
          };
        });
        parent.addEventListener('mouseleave', () => this.$data.visible = false);
      }, 1);
  }

  public data() {
    return {
      visible: false,
      stylePosition: {},
      options: optionsService.options,
    };
  }

  public extractUniquCapacities(card: ICard): string[] {
    const ret: string[] = [];
    if (!card.stats) {
      return [];
    }

    if (this.cardStats) {
      if (this.cardStats.capacities) {
        ret.push(...this.cardStats.capacities);
      }

      ['top', 'right', 'bottom', 'left'].forEach((side: string) => {
        const stats: any = this.cardStats;
        const statSide: ICardSideStat|undefined = stats[side];
        if (statSide && statSide.capacity && !ret.includes(statSide.capacity)) {
          ret.push(statSide.capacity);
        }
      });
    } else {
      if (card.stats.capacities) {
        ret.push(...card.stats.capacities);
      }

      ['top', 'right', 'bottom', 'left'].forEach((side: string) => {
        const stats: any = card.stats;
        const statSide: ICardSideStat|undefined = stats[side];
        if (statSide && statSide.capacity && !ret.includes(statSide.capacity)) {
          ret.push(statSide.capacity);
        }
      });
    }

    return ret;
  }

  public get displayCardStatsChanged(): boolean {
    return !!(
      this.cardFocus &&
      this.cardStats &&
      JSON.stringify(this.cardFocus.stats) !== JSON.stringify(this.cardStats));
  }
}
